import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IFurnizorAddPayload, IFurnizorUpdatePayload } from './furnizori-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class FurnizoriProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listFurnizoriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.list;
    private listDTFurnizoriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.listDT;
    private addFurnizorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.store;
    private updateFurnizorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.update;
    private deleteFurnizorURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.changeActive;
    private listStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteProvider.listActive;

    constructor(private http: HttpClient) { }

    listFurnizori() {
        return this.http.get(this.listFurnizoriURL);
    }

    listDTFurnizori() {
        return this.http.post(this.listDTFurnizoriURL, {});
    }

    addFurnizor(data: IFurnizorAddPayload) {
        return this.http.post(this.addFurnizorURL, data);
    }

    updateFurnizor(data: IFurnizorUpdatePayload) {
        return this.http.put(this.updateFurnizorURL, data);
    }

    deleteFurnizor(id: number) {
        return this.http.delete(this.deleteFurnizorURL + id);
    }

    listStatusActive() {
        return this.http.get(this.listStatusActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
